// Excel експортът на „По станции".
//
// Редовете идват ФИЛТРИРАНИ и ПОДРЕДЕНИ от таблицата (`onFilteredRowsChange`),
// не суровият отговор — файлът повтаря екрана. Числата остават ЧИСЛА.
//
// Колоните за методи са СЪЩИТЕ като на екрана — всички активни методи, със
// смесеното разпределено в „В брой" и „С карта".

import { exportToExcel, type ExcelColumn } from "../../../../utils/excelExport";
import type { MethodEntry } from "../../../../utils/paymentMethodsDisplay";
import type { StationRow } from "./stationsMath";

type Options = {
  rows: StationRow[];
  methodEntries: MethodEntry[];
  showVoids: boolean;
  showDelta: boolean;
  /** Втори аргумент за ключовете с параметър (`{{method}}`). */
  t: (key: string, options?: Record<string, unknown>) => string;
};

const round = (value: number) => Number(value.toFixed(2));

export const exportStations = ({
  rows,
  methodEntries,
  showVoids,
  showDelta,
  t,
}: Options) => {
  const columns: ExcelColumn<StationRow>[] = [
    {
      header: t("reportsPage.station"),
      value: (row) => row.stationName,
      width: 24,
    },
    {
      header: t("reportsPage.stationsBillsColumn"),
      value: (row) => row.bills,
      width: 12,
    },
    {
      header: t("reportsPage.stationsRevenueColumn"),
      value: (row) => round(row.revenue),
      width: 14,
    },
    {
      header: t("reportsPage.stationsShareColumn"),
      value: (row) => Number(row.share.toFixed(1)),
      width: 10,
    },
  ];

  for (const entry of methodEntries) {
    columns.push({
      header: entry.label,
      value: (row) => round(row.methodAmounts.get(entry.id) ?? 0),
      width: 14,
    });
  }

  if (showVoids) {
    columns.push({
      header: t("reportsPage.stationsVoidsColumn"),
      value: (row) => round(row.voidTotal),
      width: 14,
    });
  }

  if (showDelta) {
    columns.push({
      header: t("reportsPage.stationsDeltaColumn"),
      // Празно, а не нула: липсващата Δ значи „няма с какво да се сравни".
      value: (row) => (row.delta === null ? "" : Number(row.delta.toFixed(1))),
      width: 14,
    });
  }

  exportToExcel<StationRow>({
    filename: t("reportsPage.stationsPageTitle"),
    sheetName: t("reportsPage.stationsReport"),
    columns,
    rows,
  });
};
